import axios from "axios";
import Cookies from "universal-cookie";
import { isNULLEMPTYORUNDEFINED } from "../../common/utility";

const handlePostUserPaymentDetails = async ({
    paymentDetails,
    setSnackBarOpen,
    setSnackBarClose,
    setLoading,
    courseIds,
    emailList,
}) => {
    try {
        // Create loading entries for each email and course combination
        const loadingEntries = [];
        emailList.forEach((currentEmail) => {
            courseIds.forEach((courseId) => {
                loadingEntries.push({
                    email: currentEmail,
                    courseId: parseInt(courseId),
                    hasCompleted: false,
                });
            });
        });
        setLoading(loadingEntries);

        // Process each email with each course
        const processEntries = async () => {
            let entryIndex = 0;
            for (const currentEmail of emailList) {
                for (const courseId of courseIds) {
                    const isSuccessful = await postUserPaymentDetails({
                        ...paymentDetails,
                        Email: currentEmail,
                        Course_Id: parseInt(courseId),
                    });
                    const index = entryIndex;
                    setLoading((prev) => {
                        const newLoadingValues = [...prev];
                        newLoadingValues[index].hasCompleted = true;
                        newLoadingValues[index].isSuccessful = isSuccessful;
                        return newLoadingValues;
                    });
                    entryIndex++;
                }
            }
        };

        await processEntries();
        setSnackBarOpen(true);
    } catch (err) {
        // setLoading(false);
        setSnackBarClose(true);
        console.error("error is ", err);
    }
};

const postUserPaymentDetails = async (data) => {
    try {
        const cookies = new Cookies();
        await axios.post(process.env.REACT_APP_BACKEND_ADMIN_URL + "/externalPayments/postUserPaymentDetails", data, {
            headers: {
                "Content-Type": "application/json",
                authorization: cookies.get("old-admin"),
            },
        });
        return true;
    } catch (err) {
        console.log("Payment Error:", err);
        return false;
    }
};

const handleGetUserPaymentHistory = async ({ email, courseIds, setPaymentHistory, setHistoryLoading }) => {
    try {
        setHistoryLoading(true);
        setPaymentHistory([]);
        for (let i = 0; i < courseIds.length; i++) {
            let data = {
                email: email,
                course_id: parseInt(courseIds[i]),
            };
            const res = await getUserPaymentHistory({ data });
            if (!isNULLEMPTYORUNDEFINED(res)) {
                setPaymentHistory((prev) => [...prev, ...res]);
            }
        }
    } catch (err) {
        console.error("Payment History failed:", err);
    } finally {
        setHistoryLoading(false);
    }
};

const getUserPaymentHistory = async ({ data }) => {
    try {
        const cookies = new Cookies();
        const res = await axios.post(
            process.env.REACT_APP_BACKEND_ADMIN_URL + "/externalPayments/getUserPaymentHistory",
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: cookies.get("old-admin"),
                },
            }
        );
        return res.data;
    } catch (err) {
        console.error("Error:", err);
        return [];
    }
};

export { handlePostUserPaymentDetails, handleGetUserPaymentHistory };
